import React from 'react';

import styles from './ConfirmationBox.module.scss';
import Loader from "../Loader/Loader";
import Modal from "../Modal/Modal";


class ConfirmationBox extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false
        };


    }

    closeModal() {
        this.props.onClose();
    }

    confirmButtonClickHandler() {
        if (this.props.confirmButtonAction) {
            this.props.confirmButtonAction();
        } else {
            this.props.onClose();
        }
    }

    cancelButtonClickHandler() {
        if (this.props.cancelButtonAction) {
            this.props.cancelButtonAction();
        } else {
            this.props.onClose();
        }
    }

    renderContent() {
        return (
            <div className={styles.container}>
                <div className={styles.contentContainer}>
                    {this.props.content ? this.props.content : ''}
                </div>
                <div className={styles.buttonsRow}>
                    {
                        this.props.cancelButtonShow ?
                            <div className={styles.buttonContainer}>
                                {
                                    this.props.cancelButtonShow ?
                                        <div className={'alma-button'}
                                             onClick={() => this.cancelButtonClickHandler()}>{this.props.cancelButtonText}</div>
                                        :
                                        null
                                }
                            </div>
                            :
                            null
                    }
                    {
                        this.props.confirmButtonShow ?
                            <div className={styles.buttonContainer}>
                                <div className={'alma-danger-button'}
                                     onClick={() => this.confirmButtonClickHandler()}>{this.props.confirmButtonText}</div>
                            </div>
                            :
                            null
                    }
                </div>

                {this.props.loading ?
                    <div className={styles.loader}>
                        <Loader/>
                    </div>
                    :
                    null
                }
            </div>
        )
    }

    render() {
        return (
            <div>
                <Modal
                    content={this.renderContent()}
                    onClose={this.closeModal.bind(this)}
                    visible={this.props.visible}/>
            </div>
        );
    }

}

export default ConfirmationBox;
